import { useEffect, useState } from "react";
import { useSpot } from "../../../../Spot";
import { volumeCheckSpotStates } from "../volumeCheckSpotStates";
import { videoStates, audioStates } from "../../../../Spot/spotStateConstants";
import { isHighGradeBand } from "../../../../../services/ThemingService";

const renegadeSongShorter = require('../../../../../../assets/sounds/dances/Renegadev4_shorter.mp3');
const spotPantSound = require('../../../../../../assets/sounds/dances/SFX_pupping_panting_louder.mp3');
const spotBarkSound = require('../../../../../../assets/sounds/dances/SFX_cartoon-happy-puppy-bark_v2.mp3');

/**
 * extends the functionality of useSpot for volume check
 */
export function useVolumeCheckSpot(speech, initialState){
    
    const spotHook = useSpot(speech, initialState)
    const { spotState, spotStates } = spotHook
    const isHighGrade = isHighGradeBand();

    const [ volumeCheckSpotState, setVolumeCheckSpotState ] = useState(spotStates.invisible)

    /**
     * update the state here when the original Spot functionalities are used to change state.
     */
    useEffect(() => {
        setVolumeCheckSpotState(spotState)
    }, [spotState])
    

    /**
     * implement additional functionalities
     */
    const playDiscoBall = async () => {
        setVolumeCheckSpotState(volumeCheckSpotStates.discoBall)
        // Skip playing sound for high grade band users
        if (!isHighGrade) {
            await speech.playAppSoundsWithPromise({
                url: renegadeSongShorter,
                key: 'renegadeSong',
            }, 4000);
        }
    }
    const playSingleBook = () => {
        setVolumeCheckSpotState(volumeCheckSpotStates.singleBook)
    }
    const playMultipleBooks = () => {
        setVolumeCheckSpotState(volumeCheckSpotStates.multipleBooks)
    }

    /**
     * Override base Spot functionality to prevent sounds for high grade band users
     */
    const wakeUpFromSleep = async () => {
        setVolumeCheckSpotState(videoStates.wokeUpFromSleep)
        if (!isHighGrade) {
            await speech.playAppSoundsWithPromise({
                url: spotPantSound,
                key: audioStates.panting,
            }, 4000);
        }
        setVolumeCheckSpotState(videoStates.awake)
    }

    const bark = async () => {
        // Skip playing bark sound for high grade band users
        if (!isHighGrade) {
            await speech.playAppSoundsWithPromise({
                url: spotBarkSound,
                key: audioStates.bark,
            }, 2500);
        }
    }

    /**
     * return the extended version of the spot hook
     */
    return {
        ...spotHook, // copy spot's functionalities
        playDiscoBall,
        playSingleBook,
        playMultipleBooks,
        wakeUpFromSleep, // Override the original wakeUpFromSleep
        bark, // Override the original bark
        spotState: volumeCheckSpotState,
        spotStates: {
            ...spotStates,
            ...volumeCheckSpotStates // add additional available states
        },
    }
}